/**
 * A lightweight clone of the Lodash function.
 */
export default (obj) => [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
//# sourceMappingURL=is-empty.js.map